import {
  actionTypes,
} from 'redux-resource';

import type {
  ResourcesAction,
} from '../types';

export const resourceActionTypes = actionTypes;

export const addResources = ({
  resourceType,
  resources,
  list,
}: {
  resourceType: string,
  resources: Array<any>,
  list?: string,
}): ResourcesAction => ({
  type: actionTypes.READ_RESOURCES_SUCCEEDED,
  resourceType,
  resources,
  list,
});

export const updateResources = ({
  resourceType,
  resources,
  list,
}: {
  resourceType: string,
  resources: Array<any>,
  list?: string,
}): ResourcesAction => ({
  type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
  resourceType,
  resources,
  list,
});

export const deleteResources = ({
  list,
  resources,
  resourceType,
}: {
  list?: string,
  resources: Array<any>,
  resourceType: string,
}): ResourcesAction => ({
  type: actionTypes.DELETE_RESOURCES_SUCCEEDED,
  list,
  resources,
  resourceType,
});

export const selectResources = (
  resourceType: string,
  ids: Array<number>,
) => ({
  type: actionTypes.UPDATE_RESOURCES,
  resources: {
    [resourceType]: {
      selected: ids,
    },
  },
});
